import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    width: '100%'
  },
  sectionTitle: {
    fontSize: 16,
    color: theme.colorPalette.beige_60,
    fontWeight: 400,
    margin: theme.spacing(3, 0, 4, 0)
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.colorPalette.beige_60,
    margin: 0
  },
  listTotal: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  listTotalText: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.colorPalette.beige_60
  },
  listTotalCount: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.colorPalette.beige_25
  },
  addFormContainer: {
    width: '100%',
    margin: theme.spacing(2, 0),
    border: `2px solid ${theme.colorPalette.green_80}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(4, 8)
  },
  description: {
    fontSize: 10,
    lineHeight: '12px',
    marginTop: theme.spacing(-4)
  },
  addRow: {
    width: '100%'
  },
  addressColumn: {
    width: '100%',
    marginTop: -4,
    '& input': {
      textOverflow: 'ellipsis',
      paddingRight: theme.spacing(9)
    }
  },
  actionsRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    width: '100%',
    marginTop: theme.spacing(2)
  },
  additionalColumn: {
    flex: 1,
    minWidth: 0
  },
  additionalDescription: {
    fontSize: 10,
    lineHeight: '12px',
    marginTop: -10
  },
  addButton: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
    fontSize: 16,
    padding: theme.spacing(1.5, 4),
    marginTop: 16
  },
  singleBottom: {
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end'
  },
  propertyFormContainer: {
    marginTop: theme.spacing(3)
  },
  gridContainer: {
    width: '100%'
  },
  gridItem: {
    paddingRight: 0,
    '&:first-of-type': {
      paddingTop: 0
    }
  },
  relativeGridItem: {
    paddingRight: 0,
    position: 'relative'
  },
  propertyItem: {
    backgroundColor: theme.colorPalette.green_80,
    padding: theme.spacing(2, 4),
    borderBottom: `0.5px solid ${theme.colorPalette.beige_50_op_75}`,
    width: '100%',
    '&:first-of-type': {
      borderTopLeftRadius: theme.sizes.roundCorners,
      borderTopRightRadius: theme.sizes.roundCorners
    },
    '&:last-of-type': {
      borderBottomLeftRadius: theme.sizes.roundCorners,
      borderBottomRightRadius: theme.sizes.roundCorners,
      borderBottom: 'none'
    }
  },
  propertyContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  propertyInfo: {
    flex: 1,
    minWidth: 0
  },
  propertyTitle: {
    fontSize: 14,
    fontWeight: 400,
    margin: '0 0 4px 0',
    color: theme.colorPalette.beige_50
  },
  propertyAddress: {
    fontSize: 10,
    fontWeight: 600,
    margin: 0,
    color: theme.colorPalette.beige_50,
    textTransform: 'uppercase',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  deleteButton: {
    color: theme.colorPalette.orange_75
  },
  tooltipFieldLabel: {
    position: 'absolute',
    right: 0,
    top: 0
  }
});

export default makeStyles(styles);
